export const PRESCRIPTION_STATUS_OPTIONS = [
  { label: "Accepted", value: "accepted" },
  { label: "Changed", value: "changed" },
  { label: "Clarification", value: "clarify" },
  { label: "Clarified", value: "clarified" },
  { label: "Contact attempted 1", value: "contact_attempted" },
  { label: "Contact attempted 2", value: "contact_attempted_2" },
  { label: "Contact attempted 3", value: "contact_attempted_3" },
  { label: "Contact Made", value: "contact_made" },
  { label: "Declined", value: "declined" },
  { label: "Delayed entry", value: "delayed_entry" },
  { label: "Denied", value: "denied" },
  { label: "New", value: "new" },
  { label: "No contact", value: "no_contact" },
  { label: "On Hold", value: "on_hold" },
  { label: "Patient hold", value: "patient_hold" },
  { label: "Refill", value: "refill" },
  { label: "Refill with change", value: "refill_with_change" },
  { label: "Expired", value: "expired" },
  { label: "Deleted", value: "deleted" },
];

export const PLAN_STATUS_OPTIONS = [
  { label: "Active", value: "active" },
  { label: "Activated - Pending start", value: "activated - pending start" },
  { label: "Active - Payments complete", value: "active - payments complete" },
  { label: "Paused", value: "paused" },
  { label: "Cancelled", value: "cancelled" },
  { label: "Awaiting payment", value: "awaiting payment" },
  { label: "Failed payment", value: "failed payment" },
];

export const ROLE_OPTIONS = [
  { label: "Administrator", value: "business_administrator" },
  { label: "Management", value: "business_management" },
  { label: "Operations", value: "business_operations" },
  { label: "Predictile Administrator", value: "predictile_administrator" },
  { label: "Predictile Management", value: "predictile_management" },
  { label: "Predictile Operations", value: "predictile_operations" },
];

export const VIEWABLE_EXTENSIONS = ["docx", "pdf", "png", "jpeg", "jpg", "xlsx", "pptx"];

export const STATE_OPTIONS = [
  { value: "AL", name: "Alabama" },
  { value: "AK", name: "Alaska" },
  { value: "AZ", name: "Arizona" },
  { value: "AR", name: "Arkansas" },
  { value: "CA", name: "California" },
  { value: "CO", name: "Colorado" },
  { value: "CT", name: "Connecticut" },
  { value: "DC", name: "District of Columbia" },
  { value: "DE", name: "Delaware" },
  { value: "FL", name: "Florida" },
  { value: "GA", name: "Georgia" },
  { value: "HI", name: "Hawaii" },
  { value: "ID", name: "Idaho" },
  { value: "IL", name: "Illinois" },
  { value: "IN", name: "Indiana" },
  { value: "IA", name: "Iowa" },
  { value: "KS", name: "Kansas" },
  { value: "KY", name: "Kentucky" },
  { value: "LA", name: "Louisiana" },
  { value: "ME", name: "Maine" },
  { value: "MD", name: "Maryland" },
  { value: "MA", name: "Massachusetts" },
  { value: "MI", name: "Michigan" },
  { value: "MN", name: "Minnesota" },
  { value: "MS", name: "Mississippi" },
  { value: "MO", name: "Missouri" },
  { value: "MT", name: "Montana" },
  { value: "NE", name: "Nebraska" },
  { value: "NV", name: "Nevada" },
  { value: "NH", name: "New Hampshire" },
  { value: "NJ", name: "New Jersey" },
  { value: "NM", name: "New Mexico" },
  { value: "NY", name: "New York" },
  { value: "NC", name: "North Carolina" },
  { value: "ND", name: "North Dakota" },
  { value: "OH", name: "Ohio" },
  { value: "OK", name: "Oklahoma" },
  { value: "OR", name: "Oregon" },
  { value: "PA", name: "Pennsylvania" },
  { value: "RI", name: "Rhode Island" },
  { value: "SC", name: "South Carolina" },
  { value: "SD", name: "South Dakota" },
  { value: "TN", name: "Tennessee" },
  { value: "TX", name: "Texas" },
  { value: "UT", name: "Utah" },
  { value: "VT", name: "Vermont" },
  { value: "VA", name: "Virginia" },
  { value: "WA", name: "Washington" },
  { value: "WV", name: "West  Virginia" },
  { value: "WI", name: "Wisconsin" },
  { value: "WY", name: "Wyoming" },
];
export const STATE_TIMEZONES = {
  AL: "America/Chicago",
  AK: "America/Anchorage",
  AZ: "America/Phoenix",
  AR: "America/Chicago",
  CA: "America/Los_Angeles",
  CO: "America/Denver",
  CT: "America/New_York",
  DC: "America/New_York",
  DE: "America/New_York",
  FL: "America/New_York",
  GA: "America/New_York",
  HI: "Pacific/Honolulu",
  ID: "America/Boise",
  IL: "America/Chicago",
  IN: "America/Indiana/Indianapolis",
  IA: "America/Chicago",
  KS: "America/Chicago",
  KY: "America/New_York",
  LA: "America/Chicago",
  ME: "America/New_York",
  MD: "America/New_York",
  MA: "America/New_York",
  MI: "America/Detroit",
  MN: "America/Chicago",
  MS: "America/Chicago",
  MO: "America/Chicago",
  MT: "America/Denver",
  NE: "America/Chicago",
  NV: "America/Los_Angeles",
  NH: "America/New_York",
  NJ: "America/New_York",
  NM: "America/Denver",
  NY: "America/New_York",
  NC: "America/New_York",
  ND: "America/Chicago",
  OH: "America/New_York",
  OK: "America/Chicago",
  OR: "America/Los_Angeles",
  PA: "America/New_York",
  RI: "America/New_York",
  SC: "America/New_York",
  SD: "America/Chicago",
  TN: "America/Chicago",
  TX: "America/Chicago",
  UT: "America/Denver",
  VT: "America/New_York",
  VA: "America/New_York",
  WA: "America/Los_Angeles",
  WV: "America/New_York",
  WI: "America/Chicago",
  WY: "America/Denver",
};
